// Derive the URL of a resized mentor-photo variant produced by the storage-resize-images
// extension. Originals live at mentor-photos/{id}/profile.jpg; the extension writes
// variants beside them as profile_{W}x{H}.webp. mentor-photos has `allow read: if true`
// (storage.rules), so the variant is reachable via a TOKENLESS Firebase download URL —
// no per-object token needed, no extension "make public" config required.
//
// Returns null when the input isn't a recognizable Firebase download URL (callers then
// just use the original). Even when a URL is returned, the variant may not exist yet (the
// backfill hasn't run) — so the <img> must keep an onError fallback to the original.

export function thumbUrl(downloadUrl: string | null | undefined, size: number): string | null {
  if (!downloadUrl) return null;
  // https://firebasestorage.googleapis.com/v0/b/BUCKET/o/ENCODED_PATH?alt=media&token=...
  const m = /^(https:\/\/firebasestorage\.googleapis\.com\/v0\/b\/[^/]+\/o\/)([^?]+)(?:\?.*)?$/.exec(downloadUrl);
  if (!m) return null;
  const prefix = m[1]!;
  let path: string;
  try {
    path = decodeURIComponent(m[2]!); // mentor-photos/{id}/profile.jpg
  } catch {
    return null;
  }
  const dot = path.lastIndexOf('.');
  if (dot < 0) return null;
  const variantPath = `${path.slice(0, dot)}_${size}x${size}.webp`;
  return `${prefix}${encodeURIComponent(variantPath)}?alt=media`;
}
